/* ============================================================
   NATIVO POPUP · v1 · Klaviyo events + subscribe + display rules
   Config viene de window.NATIVO_POPUP_CONFIG (inyectado por Liquid)
   ============================================================ */
(function(){
  'use strict';

  /* Disable popup on /en/ locale (English market) — Spanish only */
  var _path = window.location.pathname || '';
  if (_path === '/en' || _path.indexOf('/en/') === 0) {
    var _ovEN = document.getElementById('npOverlay');
    if (_ovEN) { _ovEN.style.display = 'none'; _ovEN.setAttribute('hidden', ''); }
    console.log('[Nativo Popup] disabled in EN locale — exiting');
    return;
  }

  var cfg = window.NATIVO_POPUP_CONFIG || {};
  if (!cfg.enabled) {
    console.log('[Nativo Popup] disabled by config — exiting');
    return;
  }
  if (!cfg.klaviyo_company_id) {
    console.warn('[Nativo Popup] missing klaviyo_company_id — Klaviyo integration disabled');
  }

  /* === State (localStorage) === */
  var STATE_KEY = 'nativo_popup_state';
  function loadState(){ try { return JSON.parse(localStorage.getItem(STATE_KEY) || '{}'); } catch(e){ return {}; } }
  function saveState(){ try { localStorage.setItem(STATE_KEY, JSON.stringify(state)); } catch(e){} }
  var state = loadState();

  /* === Display rules === */
  function shouldShow(){
    if (state.converted) return false;  /* never show again if user converted */
    var now = Date.now();
    if (state.lastDismissed) {
      var cooldownMs = (cfg.cooldown_days || 7) * 86400000;
      if (now - state.lastDismissed < cooldownMs) return false;
    }
    var isMobile = window.innerWidth <= 768;
    if (isMobile && !cfg.show_on_mobile) return false;
    if (!isMobile && !cfg.show_on_desktop) return false;
    if (cfg.excluded_paths) {
      var paths = String(cfg.excluded_paths).split('|').map(function(s){ return s.trim(); }).filter(Boolean);
      for (var i = 0; i < paths.length; i++) {
        if (window.location.pathname.indexOf(paths[i]) === 0) return false;
      }
    }
    return true;
  }

  /* === Klaviyo client-side API === */
  var KLAVIYO_BASE = 'https://a.klaviyo.com/client';
  var KLAVIYO_REVISION = '2025-07-15';

  /* Events are BUFFERED until the visitor is identified (email or phone given).
     This prevents Klaviyo from creating empty anonymous profiles for every
     popup impression. When the visitor identifies, all buffered events are
     flushed with their original timestamps, attributed to the now-known profile. */
  var pendingEvents = [];

  function trackEvent(name, properties){
    if (!cfg.klaviyo_company_id) return;
    properties = properties || {};
    properties.source = 'nativo_popup';
    properties.page_url = window.location.href;
    properties.page_path = window.location.pathname;
    properties.device = window.innerWidth <= 768 ? 'mobile' : 'desktop';

    /* Not identified yet — buffer in memory, do NOT hit Klaviyo */
    if (!leadData.email && !leadData.phone) {
      pendingEvents.push({ name: name, properties: properties, time: new Date().toISOString() });
      return;
    }

    /* Profile identified — flush any pending events first, then send the new one */
    flushPendingEvents();
    sendEvent(name, properties, null);
  }

  function flushPendingEvents(){
    if (pendingEvents.length === 0) return;
    var buf = pendingEvents.slice();
    pendingEvents = [];
    for (var i = 0; i < buf.length; i++) {
      sendEvent(buf[i].name, buf[i].properties, buf[i].time);
    }
  }

  function sendEvent(name, properties, timeIso){
    /* Safety: never send without an identified profile */
    if (!leadData.email && !leadData.phone) return;
    if (!cfg.klaviyo_company_id) return;

    var profileAttrs = {};
    if (leadData.email) profileAttrs.email = leadData.email;
    if (leadData.phone) profileAttrs.phone_number = leadData.phone;

    var eventAttrs = {
      properties: properties,
      metric: { data: { type: 'metric', attributes: { name: name } } },
      profile: { data: { type: 'profile', attributes: profileAttrs } }
    };
    /* Preserve original timestamp for buffered events */
    if (timeIso) eventAttrs.time = timeIso;

    fetch(KLAVIYO_BASE + '/events/?company_id=' + encodeURIComponent(cfg.klaviyo_company_id), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_REVISION },
      body: JSON.stringify({ data: { type: 'event', attributes: eventAttrs } }),
      keepalive: true,
      mode: 'cors'
    }).catch(function(err){ console.warn('[Nativo Popup] send event "' + name + '" error:', err); });
  }

  function subscribe(listId, profileAttrs, customSource){
    if (!cfg.klaviyo_company_id || !listId) return Promise.reject(new Error('missing klaviyo config'));
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: customSource || 'Nativo Popup',
          profile: { data: { type: 'profile', attributes: profileAttrs } }
        },
        relationships: {
          list: { data: { type: 'list', id: listId } }
        }
      }
    };
    return fetch(KLAVIYO_BASE + '/subscriptions/?company_id=' + encodeURIComponent(cfg.klaviyo_company_id), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_REVISION },
      body: JSON.stringify(body),
      mode: 'cors'
    });
  }

  /* === Popup state === */
  var overlay = null;
  var currentScreen = 1;
  var popupShownAt = null;
  var leadData = { quiz: null, email: null, phone: null };
  var phoneIti = null;

  var _savedScrollY = 0;
  function showPopup(){
    if (!shouldShow()) return;
    if (!overlay) return;
    /* iOS-friendly scroll lock: save scrollY, fix body position to avoid bounce */
    _savedScrollY = window.scrollY || window.pageYOffset || 0;
    overlay.classList.add('is-open');
    overlay.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + _savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    popupShownAt = Date.now();
    state.lastShown = popupShownAt;
    saveState();
    trackEvent('Nativo Popup Shown', {});
  }

  function closePopup(reason){
    if (!overlay) return;
    overlay.classList.remove('is-open');
    /* Restore scroll position */
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, _savedScrollY);
    if (currentScreen < 4) {
      state.lastDismissed = Date.now();
      saveState();
      trackEvent('Nativo Popup Closed', {
        reason: reason || 'x_button',
        screen: currentScreen,
        time_open_seconds: popupShownAt ? Math.round((Date.now() - popupShownAt) / 1000) : 0
      });
    }
  }

  function showScreen(n){
    var screens = overlay.querySelectorAll('.np-screen');
    for (var i = 0; i < screens.length; i++) {
      var sn = +screens[i].getAttribute('data-screen');
      if (sn === n) screens[i].classList.add('is-active');
      else screens[i].classList.remove('is-active');
    }
    currentScreen = n;
  }

  function answerQuiz(answer){
    leadData.quiz = answer;
    trackEvent('Nativo Popup Quiz Answered', { quiz_answer: answer });
    showScreen(2);
  }

  function submitEmail(e){
    e.preventDefault();
    var input = document.getElementById('npEmail');
    var email = input.value.trim();
    if (!email) return false;
    leadData.email = email;

    subscribe(cfg.klaviyo_email_list_id, {
      email: email,
      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
    }, 'Nativo Popup — Email Step').then(function(r){
      trackEvent('Nativo Popup Email Submitted', {
        quiz_answer: leadData.quiz,
        klaviyo_status: r.status
      });
    }).catch(function(err){
      console.warn('[Nativo Popup] subscribe email failed:', err);
      trackEvent('Nativo Popup Email Submitted', {
        quiz_answer: leadData.quiz,
        error: String(err && err.message || err)
      });
    });

    showScreen(3);
    return false;
  }

  function submitPhone(e){
    e.preventDefault();
    var errorEl = document.getElementById('npPhoneError');
    if (errorEl) errorEl.classList.remove('is-visible');

    var phone = '';
    if (phoneIti) {
      phone = phoneIti.getNumber();
      if (typeof phoneIti.isValidNumber === 'function' && !phoneIti.isValidNumber()) {
        if (errorEl) errorEl.classList.add('is-visible');
        return false;
      }
    } else {
      phone = document.getElementById('npPhone').value.trim();
    }
    if (!phone) {
      if (errorEl) errorEl.classList.add('is-visible');
      return false;
    }
    leadData.phone = phone;

    var profileAttrs = {
      phone_number: phone,
      subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } }
    };
    if (leadData.email) profileAttrs.email = leadData.email;

    subscribe(cfg.klaviyo_sms_list_id, profileAttrs, 'Nativo Popup — Phone Step').then(function(r){
      trackEvent('Nativo Popup Phone Submitted', {
        quiz_answer: leadData.quiz,
        has_email: !!leadData.email,
        klaviyo_status: r.status
      });
    }).catch(function(err){
      console.warn('[Nativo Popup] subscribe sms failed:', err);
    });

    goToSuccess();
    return false;
  }

  function goToSuccess(){
    showScreen(4);
    state.converted = true;
    saveState();
    trackEvent('Nativo Popup Completed', {
      quiz_answer: leadData.quiz,
      has_email: !!leadData.email,
      has_phone: !!leadData.phone,
      time_to_convert_seconds: popupShownAt ? Math.round((Date.now() - popupShownAt) / 1000) : 0
    });
  }

  /* === Display triggers === */
  function setupTriggers(){
    var triggered = false;
    function triggerOnce(){ if (triggered) return; triggered = true; showPopup(); }

    /* 1. Time delay (always primary trigger) */
    var delay = +cfg.delay_seconds;
    if (!isNaN(delay) && delay >= 0) {
      setTimeout(triggerOnce, delay * 1000);
    }

    /* 2. Scroll % trigger */
    var scrollPct = +cfg.scroll_trigger;
    if (!isNaN(scrollPct) && scrollPct > 0 && scrollPct < 100) {
      window.addEventListener('scroll', function(){
        if (triggered) return;
        var maxScroll = document.body.scrollHeight - window.innerHeight;
        if (maxScroll <= 0) return;
        var pct = (window.scrollY / maxScroll) * 100;
        if (pct >= scrollPct) triggerOnce();
      }, { passive: true });
    }

    /* 3. Exit intent (desktop only) */
    if (cfg.exit_intent && window.innerWidth > 768) {
      document.addEventListener('mouseleave', function(e){
        if (triggered) return;
        if (e.clientY <= 0) triggerOnce();
      });
    }
  }

  /* === Init === */
  function init(){
    overlay = document.getElementById('npOverlay');
    if (!overlay) {
      console.warn('[Nativo Popup] overlay element #npOverlay not found');
      return;
    }

    /* Wire up buttons */
    var closeBtns = overlay.querySelectorAll('[data-np-close]');
    for (var i = 0; i < closeBtns.length; i++) {
      closeBtns[i].addEventListener('click', function(){ closePopup('x_button'); });
    }

    var quizBtns = overlay.querySelectorAll('[data-np-quiz]');
    for (var j = 0; j < quizBtns.length; j++) {
      (function(btn){
        btn.addEventListener('click', function(){ answerQuiz(btn.getAttribute('data-np-quiz')); });
      })(quizBtns[j]);
    }

    var skipBtns = overlay.querySelectorAll('[data-np-skip]');
    for (var k = 0; k < skipBtns.length; k++) {
      (function(btn){
        btn.addEventListener('click', function(){
          if (currentScreen === 3) goToSuccess();
          else closePopup('skip');
        });
      })(skipBtns[k]);
    }

    var emailForm = document.getElementById('npFormEmail');
    if (emailForm) emailForm.addEventListener('submit', submitEmail);
    var phoneForm = document.getElementById('npFormPhone');
    if (phoneForm) phoneForm.addEventListener('submit', submitPhone);

    /* Initialize intl-tel-input on the phone field */
    var phoneInput = document.getElementById('npPhone');
    if (phoneInput && window.intlTelInput) {
      phoneIti = window.intlTelInput(phoneInput, {
        initialCountry: 'auto',
        geoIpLookup: function(callback){
          fetch('https://ipapi.co/json/', { cache: 'no-store' })
            .then(function(r){ return r.json(); })
            .then(function(d){ callback((d && d.country_code) ? d.country_code : 'uy'); })
            .catch(function(){ callback('uy'); });
        },
        preferredCountries: ['uy','ar','mx','us','es','br','cl','pe','co'],
        separateDialCode: true,
        formatOnDisplay: true,
        autoPlaceholder: 'aggressive',
        nationalMode: true,
        dropdownContainer: document.body,
        utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@18.5.1/build/js/utils.js'
      });

      /* Live format as user types */
      var isFmt = false;
      phoneInput.addEventListener('input', function(){
        if (isFmt || typeof window.intlTelInputUtils === 'undefined' || !phoneIti) return;
        var cur = phoneInput.selectionStart;
        var before = phoneInput.value;
        var country = phoneIti.getSelectedCountryData();
        if (!country || !country.iso2) return;
        var formatted = window.intlTelInputUtils.formatNumber(
          before, country.iso2.toUpperCase(),
          window.intlTelInputUtils.numberFormat.NATIONAL
        );
        if (formatted && formatted !== before) {
          isFmt = true;
          phoneInput.value = formatted;
          var diff = formatted.length - before.length;
          phoneInput.setSelectionRange(Math.max(0, cur + diff), Math.max(0, cur + diff));
          isFmt = false;
        }
      });

      phoneInput.addEventListener('focus', function(){
        var err = document.getElementById('npPhoneError');
        if (err) err.classList.remove('is-visible');
      });
    }

    /* Esc key closes */
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closePopup('esc');
    });

    /* Start display triggers */
    setupTriggers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Debug helper: window.NativoPopup.show() / .close() / .reset() */
  window.NativoPopup = {
    show: function(){ state.lastDismissed = null; state.converted = false; saveState(); showPopup(); },
    close: function(){ closePopup('manual'); },
    reset: function(){ localStorage.removeItem(STATE_KEY); localStorage.removeItem('nativo_anon_id'); pendingEvents = []; console.log('[Nativo Popup] state reset'); },
    getState: function(){ return state; },
    getLeadData: function(){ return leadData; }
  };
})();

